<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managetransferrole/_update/updateSubrole.vue'
export default {
  components: {
    createContent
  }
}
</script>
